import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { cleanFeature } from './timeseries.service';
import { TerrakioLayerMin } from './terrakio-layer';
import { Observable } from 'rxjs';
import { InterpolationService } from 'map-wald';

@Injectable()
export class DataDownloadService {
  defaultEndpoint: string;

  constructor(private http:HttpClient) { }

    forPolygon(geoJSON: any, layer: TerrakioLayerMin,expression:string): Observable<Blob> {
      geoJSON = cleanFeature(geoJSON);
      // let v = layer.variable || layer.shortVariable;
      // let expression = '';
      // if(layer.script){
      //   expression = InterpolationService.interpolate((layer.script||[]).join('\n'),{
      //     timeRequest:'',
      //     requestVariable:v
      //   }) + `\n${v}`;
      // } else {
      //   expression = `${layer.collection}.${v}`;
      // }
      console.log('EXPRESSION POLYGON DRILL:\n',expression);

      const result$ = this.http.post(layer.polygonDrill||this.defaultEndpoint,{
        feature:{...geoJSON,properties:{}},
        output: 'geotiff',
        // name:layer.collection,
        // products:[v],
        in_crs:'epsg:4326',
        out_crs:'epsg:4326',
        expr:expression
      }, {
        headers: layer.polygonDrillHeaders||{},
        responseType:'blob'
      });
      return result$;
    }

}
